import FileUploadRedux from "components/molecules/FileUploadRedux";
import InputRedux from "components/molecules/InputRedux";
import { ReduxFormField } from "components/molecules/ReduxFormFields";
import { required } from "utils/validate.util";

export { default } from "./KioskHomeVideoForm";

export const fields: ReduxFormField[] = [
  {
    name: "video",
    label: "Video File",
    component: FileUploadRedux,
    validate: [required],
    FileUploadProps: { accept: [".mp4", ".webm",'.mov'] },
    cellProps: { md: 12 },
  },
];


